import { signInWithPopup } from 'firebase/auth'
import React from 'react'
import axios from 'axios'
import { auth, provider } from './FireBase'
import i18next from '../i18n'

function SiginButton() {
    const buttonStyle = {
        display: 'inline-block',
        textDecoration: 'none',
        background: '#668ad8',
        color: '#FFF',
        borderBottom: 'solid 0px #627295',
        borderRadius: '20px',
        animation: 'blink 1s infinite',
        fontFamily: 'auto',
    };

    const parentStyle = {
        display: 'flex',
        justifyContent: 'flex-end'  // 左寄せ
    };
    const signInwthGoogle = async () => {
        document.cookie = "user_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        try {
            const userData = await signInWithPopup(auth, provider);
        
            // 認証されたユーザー情報を取得
            const user = userData.user;
            console.log(user)
            // Firebaseトークンを取得
            const token = await userData.user.getIdToken();
            
           
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/google-auth`, 
            
                {
                    email: user.email,
                    name: user.displayName,
                    apiKey: user.apiKey,
                    token: token,
                    created_at: userData.user.metadata.creationTime,
                    lastLogin: userData.user.metadata.lastSignInTime,
                },
                {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json', // 正しいContent-Type
                        Authorization: `Bearer ${token}`, // トークンをヘッダーに追加
                    },
                    withCredentials: true,
                    
                }    
            
            )
            window.location.reload()
            console.log(response)
        } catch (error) {
        console.error(error)
        
        }

       

    };
    return (
        <div style={parentStyle}>
            {/* <p>{i18next.t('please_signIn')}</p> */}
        <button
            style={{...buttonStyle}}
            
            onClick={signInwthGoogle}>
            <p>{i18next.t('signIn')}</p>

            </button>
        </div>
    )

}
export default SiginButton